import {
  AvaliacaoDtoSchema,
  EligibilityResponseSchema,
  MyAvaliacoesResponseSchema,
  ReputationResponseSchema,
  type AvaliacaoDto,
  type EligibilityResponse,
  type MyAvaliacoesResponse,
  type ReputationResponse,
  type SubmeterAvaliacaoInput,
} from '@lance-x/shared';
import type { ApiClient } from '../index';

/**
 * REST surface for Avaliacao entity (Phase 13 v1.2 — RATE-01/02/03).
 *
 * Routes:
 *   - POST  /avaliacoes                                  (auth)
 *   - GET   /avaliacoes/me?eventoId=                     (auth)
 *   - GET   /eventos/:id/avaliacao-eligibility           (auth)
 *   - GET   /profissionais/:id/reputation                (PUBLIC)
 *   - GET   /empresas/:id/reputation                     (PUBLIC)
 *
 * Reputation endpoints accept either the domain id (Profissional.id / Empresa.id)
 * OR the underlying User.id — the server resolves transparently. Frontend should
 * pass whatever it has at hand from the feed/card without an extra lookup.
 */
export class AvaliacoesEndpoints {
  constructor(private readonly client: ApiClient) {}

  submeter(input: SubmeterAvaliacaoInput): Promise<AvaliacaoDto> {
    return this.client.post('/avaliacoes', input, {
      responseSchema: AvaliacaoDtoSchema,
    });
  }

  listMine(eventoId: string): Promise<MyAvaliacoesResponse> {
    return this.client.get('/avaliacoes/me', {
      query: { eventoId },
      responseSchema: MyAvaliacoesResponseSchema,
    });
  }

  getEligibility(eventoId: string): Promise<EligibilityResponse> {
    return this.client.get(`/eventos/${eventoId}/avaliacao-eligibility`, {
      responseSchema: EligibilityResponseSchema,
    });
  }

  getProfissionalReputation(
    profissionalIdOrUserId: string,
  ): Promise<ReputationResponse> {
    return this.client.get(
      `/profissionais/${profissionalIdOrUserId}/reputation`,
      {
        responseSchema: ReputationResponseSchema,
      },
    );
  }

  getEmpresaReputation(empresaIdOrUserId: string): Promise<ReputationResponse> {
    return this.client.get(`/empresas/${empresaIdOrUserId}/reputation`, {
      responseSchema: ReputationResponseSchema,
    });
  }
}
